// generated by the plop

export interface TalonAccessStateModel {
  canReadTalon: boolean;
  canReadTalonById: boolean;
  canReadDebts: boolean;
  canSaveForce: boolean;
  canWriteTalons: boolean;
  canWriteDebts: boolean;
  canReadReceiptOfTalon: boolean;
  canWriteReceiptOfTalon: boolean
  canRemoveTemplate: boolean
}

export const TALON_ACCESS_STATE_DEFAULT: TalonAccessStateModel = {
  canReadTalon: false,
  canReadTalonById: false,
  canReadDebts: false,
  canSaveForce: false,
  canWriteTalons: false,
  canWriteDebts: false,
  canReadReceiptOfTalon: false,
  canWriteReceiptOfTalon: false,
  canRemoveTemplate: false,
};


